import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormUtils } from 'src/app/utils/form-utils';

@Component({
  selector: 'app-form-field',
  templateUrl: './form-field.component.html',
  styleUrls: ['./form-field.component.scss']
})
export class FormFieldComponent {
 @Input() required: boolean = true;
 @Input() additionalMessage?: string;
  @Input() containerClass: string = 'd-flex flex-column';
  @Input() labelContainerClass: string = 'd-flex align-items-center gap-2';
  @Input() labelClass: string = 'mb-0';
 @Input() contentClass: string = 'mt-1';
 @Input() formFieldId: string;
 @Input() label: string;
 @Input() tooltip?: string;
 @Input() tooltipStyleClass?: string;
 @Input() form?: FormGroup;
 @Input() controlName?: string;

 readonly FormUtils = FormUtils;

  get isRequired(): boolean {
    return this.required;
  }
}
